import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupWarehouse } from "src/components/Shared/NewForms/NFLookupWarehouse";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

export const StockTakingsDetailMain = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput disabled fieldName={"documentNumber"} title={t("Document#")} />
        </Col>
        <Col sm={6}>
          <NFDateInput fieldName={"documentDate"} required={true} title={t("DocumentDate")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} />
        </Col>
        <Col sm={6}>
          <NFLookupWarehouse fieldName={"warehouseId"} title={t("Warehouse")} companyId={watch("companyId")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFIntInput fieldName={"amount"} title={t("Amount")} />
        </Col>
        <Col sm={6}>
          <NFIntInput fieldName={"amountingAmount"} title={t("AmoutingAmount")} />
        </Col>
      </Row>
    </>
  );
};
